import cx from 'classnames'
import React from 'react'

import { staticAsset } from '@js/common/utils'

import { TrustElement } from '@f/applications/QuizApp/partials/types'
import Icon from '@f/elements/Icon'

import './QuizTrustElements.css'

interface QuizTrustElementsProps {
  trustElement: TrustElement
}

export const QuizTrustElements = ({ trustElement }: QuizTrustElementsProps) => {
  const trustElements: { [key in TrustElement]: React.ReactNode } = {
    fertighaus_badges: (
      <ItemContainer className='f-t-centre'>
        <img
          className='QuizTrustElements_container_img'
          src='https://cdn.fertighaus.de/s/assets/badge-rating.png'
          alt='badge of quality'
        />
        <img
          className='QuizTrustElements_container_img'
          src='https://cdn.fertighaus.de/s/assets/badge-DE.png'
          alt='badge of quality'
        />
      </ItemContainer>
    ),
    largest_portal_stats: (
      <ItemContainer className='f-t-left f-t-centre:m'>
        <p className='f-t-body f-c-fo-mut'>
          Deutschlands größtes Hausbauportal:
        </p>
        <ul className='QuizTrustElements_list'>
          <li>
            <span>
              <Icon icon='build-16px' className='f-icon-030 f-c-fi-sec' />
            </span>
            <span className='f-t-body f-c-fo-mut'>400+ Baupartner</span>
          </li>
          <li>
            <span>
              <Icon icon='house-16px' className='f-icon-030 f-c-fi-sec' />
            </span>
            <span className='f-t-body f-c-fo-mut'>3500+ Häuser</span>
          </li>
        </ul>
      </ItemContainer>
    ),
    customer_rating: (
      <ItemContainer className='f-t-centre'>
        <span className='[ f-pos-rel f-d-inbl f-m-r-010 ]'>
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <span className='[ f-pos-rel ]'>
            <Icon
              icon='star-filled-16px-fill'
              className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
            />

            <span className='[ f-pos-ab f-overflow ]' style={{ left: '10px' }}>
              <Icon
                icon='star-filled-16px-fill'
                className='[ f-c-fi-bac025 f-c-st-awa f-icon-t-body ] QuizTrust_star-icon'
                style={{ marginLeft: '-10px' }}
              />
            </span>
          </span>
        </span>
        <div className='[ f-m-t-010 ]'>4,5 von 56.203 Kunden</div>
      </ItemContainer>
    ),
    known_from: (
      <ItemContainer className='QuizTrust_budget-container'>
        <p className='QuizTrust_budget-title f-t-body f-c-fo-mut'>
          Bekannt aus
        </p>
        <div className='QuizTrust_budget-badges f-d-flr f-fl-jc-sb f-fl-default'>
          <img
            src='https://cdn.fertighaus.de/images/Taggesspeigel_Trust_Logo_GS.max-165x165.png?t=bff7c3ef'
            className='BrandBadgesSection-image f-m-h-010'
            alt='Taggesspeigel Trust Logo GS'
            loading='lazy'
          />
          <img
            src='https://cdn.fertighaus.de/images/Focus_Trust_Logo_GS.max-165x165.png?t=f53bd9cf'
            className='BrandBadgesSection-image f-m-h-010'
            alt='Focus Trust Logo GS'
            loading='lazy'
          />
          <img
            src='https://cdn.fertighaus.de/images/Der_Spiegel_Trust_Logo_GS.max-165x165.png?t=0349acef'
            className='BrandBadgesSection-image f-m-h-010'
            alt='Der Spiegel Trust Logo GS'
            loading='lazy'
          />
          <img
            src='https://cdn.fertighaus.de/images/Wuestenrot_Trust_Logo_GS.max-165x165.png?t=23ac30a7'
            className='BrandBadgesSection-image f-m-h-010'
            alt='Wuestenrot Trust Logo GS'
            loading='lazy'
          />
        </div>
      </ItemContainer>
    ),
    free_unbinding: (
      <ItemContainer className='f-t-centre'>
        <Icon
          icon='heart-16px'
          className='[ f-c-fi-err f-m-r-005 ] QuizTrust_heart-icon'
        />
        <span className='f-t-body f-c-fo-mut'>
          Immer kostenlos & unverbindlich
        </span>
      </ItemContainer>
    ),
    request_stats: (
      <ItemContainer className='f-t-left f-t-centre:m'>
        <ul className='QuizTrustElements_list'>
          <li>
            <span>
              <Icon icon='clock-16px' className='f-icon-030 f-c-st-sec' />
            </span>
            <span className='f-t-body f-c-fo-mut'>
              Letzte Anfrage vor: 2 Minuten
            </span>
          </li>
          <li>
            <span className='f-d-inbl f-m-r-005'>
              <Icon icon='check-16px' className='f-icon-030 f-c-st-sec' />
            </span>
            <span className='f-t-body f-c-fo-mut'>Anfragen heute: 384</span>
          </li>
        </ul>
      </ItemContainer>
    ),
    testimonial: (
      <ItemContainer>
        <Testimonial />
      </ItemContainer>
    ),
    secure_data: (
      <ItemContainer className='f-t-centre'>
        <p className='f-t-body f-c-fo-mut'>
          Ihre Daten werden SSL-verschlüsselt übertragen
        </p>
        <img
          src={staticAsset('/images/ssl-badge.png')}
          alt='SSL-Badge'
          className='f-m-t-020'
          width={160}
          height={60}
        />
      </ItemContainer>
    ),
    '': null
  }

  return (
    <div className='QuizTrustElements_container'>
      {trustElements[trustElement]}
    </div>
  )
}

const ItemContainer = ({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div className={cx('QuizTrustElements_item-container', className)}>
      {children}
    </div>
  )
}

const Testimonial = () => {
  return (
    <div className='f-d-flr f-fl-jc-ce'>
      <div className='QuizTrust-testimonial_image-container f-m-r-010'>
        <img
          className='QuizTrust-testimonial_image'
          src={staticAsset('/images/testimonial.png')}
          alt='Peter A. testimony'
        />
      </div>
      <div className='QuizTrust_testimonial-text'>
        <span className='[ f-pos-rel f-d-inbl f-m-b-010 ]'>
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <Icon
            icon='star-filled-16px-fill'
            className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
          />
          <span className='[ f-pos-rel ]'>
            <Icon
              icon='star-filled-16px-fill'
              className='[ f-c-fi-awa f-icon-t-body f-m-r-005 ] QuizTrust_star-icon'
            />

            <span className='[ f-pos-ab f-overflow ]' style={{ left: '10px' }}>
              <Icon
                icon='star-filled-16px-fill'
                className='[ f-c-fi-bac025 f-c-st-awa f-icon-t-body ] QuizTrust_star-icon'
                style={{ marginLeft: '-10px' }}
              />
            </span>
          </span>
        </span>
        <div className='[ f-t-body f-m-b-020 f-c-fo-mut ]'>
          „Sehr hilfreicher Service. Mit den Informationen, zu denen ich Zugang
          hatte, konnte ich leicht die besten Partner auswählen, um Angebote
          anzufordern. Ich kann den Service gerne weiter empfehlen!”
        </div>
        <div className='[ f-t-body f-t-bold f-c-fo-mut ]'>
          <span> Peter A. </span> (34), Düsseldorf
        </div>
      </div>
    </div>
  )
}
